<template>
  <tender-form-label :key="index" :label="options.Name" :prop="options.Key" :rules="rules" class="form-select-checkbox" show-msg>
    <el-checkbox-group v-model="form[options.Key]" @change="selectChangeHandle">
      <el-checkbox
        :disabled="form.MARGIN_PAY_TYPE_label && form.MARGIN_PAY_TYPE_label.indexOf('无要求') === -1 && form.MARGIN_PAY_TYPE_label.length !== 0"
        label="无要求">
        无要求
      </el-checkbox>
      <el-checkbox
        :disabled="form.MARGIN_PAY_TYPE_label && form.MARGIN_PAY_TYPE_label.indexOf('无要求') !== -1"
        v-for="(obj, i) in options.Options"
        :key="i"
        :label="obj.Value">
        {{ obj.Name }}
      </el-checkbox>
    </el-checkbox-group>
  </tender-form-label>
</template>
<script>
import { mixForFormItem } from "../../../js/mixins";
import utils from "../../../js/utils";
export default {
  name: "FormSelectRadio",
  mixins: [mixForFormItem],
  data() {
    return {};
  },
  created() {
    this.setDefaultValue();
  },
  methods: {
    setDefaultValue() {
      let { form = {}, options = {} } = this;
      utils
        .readyToSetFormItemDefault(form, options)
        .then(() => {
          this.setFormItemValue(options.Value || []);
        })
        .catch(() => null);
    },
    selectChangeHandle(val) {
      if (val.indexOf("无要求") === -1) {
        this.form.MARGIN_PAY_TYPE = val;
        if (val.indexOf("其他") === -1) {
          this.form.MARGIN_PAY_TYPE_OTHER_EXPLAIN = "";
        }
      } else {
        this.form.MARGIN_PAY_TYPE = [];
        this.options.Options.forEach((item) => {
          this.form.MARGIN_PAY_TYPE.push(item.Value);
        });
      }
      this.doValidate();
    },
  },
};
</script>
<style lang="scss">
.form-select-checkbox {
  padding: 0;
  margin: 0 !important;
  .el-checkbox {
    height: 25px;
  }
  .el-checkbox__inner {
    border-color: black;
  }
  .el-checkbox__label {
    color: black;
    font-size: auto;
  }
  .el-checkbox-group {
    position: relative;
    z-index: 1;
    padding: 2px 8px;
  }
  &.tender-form-label.el-form-item--default,
  &.tender-form-label.el-form-item {
    .el-form-item__content {
      display: block;
    }
  }
  &.is-error {
    .el-form-item__error {
      top: 0;
      bottom: 0;
      right: 0;
      padding: 7px;
      text-align: right;
      color: #efdede;
      background: #efdede;
      border-bottom: 1px solid red;
    }
  }
}
</style>